"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSelect = void 0;
const select_1 = require("../../../components/select/select");
const form_field_1 = require("./form-field");
exports.FormSelect = (0, form_field_1.formFieldFactory)(select_1.Select);
//# sourceMappingURL=form-select.js.map